import type { RouteProps } from 'react-router'


import SignInPage from 'pages/signIn/SignInPage'
import DashboardPage from 'pages/dashboard/DashboardPage'
import LandingPage from 'pages/landing/LandingPage'
import ConfirmOtpPage from 'pages/confirmOtp/ConfirmOtpPage';
import OrderPage from 'pages/order/OrderPage';
import ManageProductPage from 'pages/manageProduct/manageProductPages';
import ManageAgentPage from 'pages/manageAgent/ManageAgentPage';
import CampaignPage from 'pages/campaign/CampaignPage';
import ChatPage from 'pages/chat/ChatPage';
import NotificationPage from 'pages/notification/NotificationPage';
import ProfilesPage from 'pages/profiles/ProfilesPage';
import CreateProductPage from 'pages/manageProduct/createProductPage';
import ManageAgentbyIdPage from 'pages/manageAgentbyId/manageAgentbyIdPage';
import UpdateProductPage from 'pages/manageProduct/updateProductPage';
import NotFoundPage from 'pages/notFound/NotFoundRoutePage';
import ProfileSettingPage from 'pages/profiles/ProfileSetting';
import SettingMyProfile from 'pages/profiles/SettingMyProfilePage';
import SettingmyQrCode from 'pages/profiles/SettingmyQrCodePage';
import OrderAgentByIdPage from 'pages/orderAgentById/OrderAgentByIdPage';
import SettingFactoryPage from 'pages/profiles/SettingFactoryPage';
import SettingLineAlertPage from 'pages/profiles/SettingLineAlert';
import OrderLotbyIdPage from 'pages/orderLotbyId/OrderLotByIdPage';
import PrivacyPolicy from 'pages/privacy/Privacy';
import TermsOfUse from 'pages/termsOfUse/TermsOfUse';
import RequestDeletePage from 'pages/requestDeleteAgent/requestDeleteAgent';
import SettingsPage from 'pages/settings/SettingPage';
import UserSystemPage from "pages/settings/UserSystem";
import CreateCampaignPage from 'pages/campaign/createCampaign';
import UpdateCampaignPage from 'pages/campaign/updateCampaign';
import TaxSettingPage from 'pages/settings/TaxSettingPage';
import DepartmentStockPage from 'pages/departmentStock/DepartmentStockPage';


export type RouteKey =
  | 'root'
  //| 'landing'
  | 'signIn'
  | 'dashboard'
  | 'notFound'
  | 'confirmOtp'
  | 'order'
  | 'manageProduct'
  | 'manageAgent'
  | 'requestDelete'
  | 'campaign'
  | 'chat'
  | 'notification'
  | 'profiles'
  | 'createProduct'
  | 'manageAgentById'
  | 'manageProductById'
  | 'profileSetting'
  | 'settingMyProfile'
  | 'settingMyQrCode'
  | 'oderAgentById'
  | 'settingFactory'
  | 'settingLineAlert'
  | 'orderLotById'
  | 'privacy'
  | 'termsOfUse'
  | 'settings'
  | 'userSystem'
  | 'createCampaign'
  | 'updateCampaign'
  | 'taxSetting'
  | 'departmentStock'




interface Middleware {
  requiredAuth?: boolean
  roleList: string[]
}

interface AppRoute extends RouteProps {
  key: RouteKey
  middleware?: Middleware,
}

export const paths: Record<RouteKey, string> = {
  root: '/',
 // landing: '/landing',
  signIn: '/sign-in',
  privacy: '/privacy',
  termsOfUse: '/terms-of-use',
  dashboard: '/dashboard',
  notFound: '/not-found',
  confirmOtp: '/confirm-otp',
  order: '/order',
  manageProduct: '/manage-product',
  manageAgent: '/manage-agent',
  campaign: '/campaign',
  chat: '/chat',
  notification: '/notification',
  profiles: '/profiles',
  createProduct: '/manage-product/create-product',
  manageAgentById: '/manage-agent/:id',
  requestDelete: '/manage-agent/requestDelete',
  manageProductById: '/manage-product/edit/:id',
  profileSetting: '/profiles/profile-setting',
  settingMyProfile: '/profiles/setting-my-profile',
  settingMyQrCode: 'profiles/my-qrcode',
  oderAgentById: '/order-agent/:id',
  settingFactory: '/profiles/setting-factory',
  settingLineAlert: '/profiles/setting-line-alert',
  orderLotById: '/order/order-lot/:id',
  settings: '/settings',
  userSystem: '/settings/user-system',
  createCampaign: '/campaign/create-campaign',
  updateCampaign: '/campaign/edit/:id',
  taxSetting: '/settings/tax-setting',
  departmentStock: '/department-stock',
}

export const publicRoutes: AppRoute[] = [
  // {
  //   key: 'landing',
  //   path: paths.landing,
  //   element: <LandingPage />,
  // },
  {
    key: 'signIn',
    path: paths.signIn,
    element: <SignInPage />,
  },
  {
    key: 'confirmOtp',
    path: paths.confirmOtp,
    element: <ConfirmOtpPage />,
  },
  {
    key: 'privacy',
    path: paths.privacy,
    element: <PrivacyPolicy />,
  },
  // {
  //   key: 'termsOfUse',
  //   path: paths.termsOfUse,
  //   element: <TermsOfUse />,
  // }
]

export const adminPrivateRoutes: AppRoute[] = [
  {
    key: 'dashboard',
    path: paths.dashboard,
    element: <DashboardPage />,
    middleware: {
      requiredAuth: true,
      roleList: [

      ],
    },
  },
  {
    key: 'order',
    path: paths.order,
    element: <OrderPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'manageProduct',
    path: paths.manageProduct,
    element: <ManageProductPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'manageAgent',
    path: paths.manageAgent,
    element: <ManageAgentPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'requestDelete',
    path: paths.requestDelete,
    element: <RequestDeletePage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    }
  },
  {
    key: 'campaign',
    path: paths.campaign,
    element: <CampaignPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'chat',
    path: paths.chat,
    element: <ChatPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'notification',
    path: paths.notification,
    element: <NotificationPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  }, 
  {
    key: 'profiles',
    path: paths.profiles,
    element: <ProfilesPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'createProduct',
    path: paths.createProduct,
    element: <CreateProductPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'manageAgentById',
    path: paths.manageAgentById,
    element: <ManageAgentbyIdPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'manageProductById',
    path: paths.manageProductById,
    element: <UpdateProductPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'profileSetting',
    path: paths.profileSetting,
    element: <ProfileSettingPage />,
  },
  {
    key: 'settingMyProfile',
    path: paths.settingMyProfile,
    element: <SettingMyProfile />,
  },
  {
    key: 'settingMyQrCode',
    path: paths.settingMyQrCode,
    element: <SettingmyQrCode />,
  },
  {
    key: 'settingFactory',
    path: paths.settingFactory,
    element: <SettingFactoryPage />,
  }, 
  {
    key: 'settingLineAlert',
    path: paths.settingLineAlert,
    element: <SettingLineAlertPage />,
  },
  {
    key: 'oderAgentById',
    path: paths.oderAgentById,
    element: <OrderAgentByIdPage />,
  },
  {
    key: 'orderLotById',
    path: paths.orderLotById,
    element: <OrderLotbyIdPage/>
  },
  {
    key: 'notFound',
    path: paths.notFound,
    element: <NotFoundPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'settings',
    path: paths.settings,
    element: <SettingsPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'userSystem',
    path: paths.userSystem,
    element: <UserSystemPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'createCampaign',
    path: paths.createCampaign,
    element: <CreateCampaignPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'updateCampaign',
    path: paths.updateCampaign,
    element: <UpdateCampaignPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'taxSetting',
    path: paths.taxSetting,
    element: <TaxSettingPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  },
  {
    key: 'departmentStock',
    path: paths.departmentStock,
    element: <DepartmentStockPage />,
    middleware: {
      requiredAuth: true,
      roleList: [],
    },
  }

]



export const rolePermission = (accessToken: string | null  | undefined , route: AppRoute ) => {

  if (!accessToken) {
    return false
  }


  // const { roleList } = route.middleware || {}
  // const role  = user.role?.name 

  // if(!role){
  //   return false
  // }


  // if (roleList?.includes(role)) {
  //   return true
  // }
  return false
}


